import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DataTranscriberValidationForm from "../../Forms/DataTranscriberValidationForm/DataTranscriberValidationForm";
import { completeDataTranscriberValidation } from "./redux-objects/actions";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import { Button, Form, Row, Col } from "react-bootstrap";
import * as documentDownloadService from "../../../services/documentDownloadService";
import { UserInfo } from "../../Login/common/defaults";
import * as urls from "../../shared/urls";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import {
  IAppRouteLocation,
  IWorkflowItemStep
} from "../../../common/sharedTypes";
import "./datatranscribervalidation.css";
import "./dataentryform.css";
import { toast } from "react-toastify";
import NotificationTemplateSelector from "../../NotificationTemplate/NotificationTemplateSelector";
import * as optionIds from "../../shared/optionIds";
import CommentsButton from "../../Comments/CommentsButton";
import CorrespondenceButton from "../../Correspondence/CorrespondenceButton";
import DriverPdfsButton from "../../shared/DriverPdfsButton/DriverPdfsButton";
import ViewAllButton from "../../DocumentViewer/ViewAllButton";
import InfoButtonBar from "../common/InfoButtonBar";

enum ServiceEndPoints {
  CompletePaperDataTranscriberValidation = "CompletePaperDataTranscriberValidation",
  SaveDataTranscriberValidation = "SaveDataTranscriberValidation",
  GetPaperPdf = "GetPaperPdf"
}

export interface IDataTranscriberValidationActionProps {
  completeDataTranscriberValidation?: (
    url: string,
    itemStep: IWorkflowItemStep,
    data: any,
    moveToNextWorkflow: boolean,
    assignNext: boolean
  ) => Promise<ApiResponse<any>>;
}

interface IDataTranscriberValidationStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  currentUser: UserInfo;
  bypassReportImage: boolean;
}

interface IDataTranscriberValidationOwnProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  history: any;
  data?: any;
  crashKey?: any;
  readOnly?: boolean;
  returnToAdvancedQuery?: boolean;
  reportId?: number;
}

interface IDataTranscriberValidationProps
  extends IDataTranscriberValidationStateProps,
  IDataTranscriberValidationOwnProps,
  IDataTranscriberValidationActionProps { }

interface IDataTranscriberValidationOwnState {
  data: any;
  formIsValid: boolean;
  isCompleting: boolean;
  spdCheckbox: boolean;
  spdDisabled: boolean;
  workZoneCheckbox: boolean;
  workZoneDisabled: boolean;
  openWorkflowItemStep?: IWorkflowItemStep;
}

class DataTranscriberValidation extends React.Component<
  IDataTranscriberValidationProps,
  IDataTranscriberValidationOwnState
> {
  constructor(props: IDataTranscriberValidationProps) {
    super(props);

    this.state = {
      data: {},
      formIsValid: false,
      isCompleting: false,
      spdCheckbox: false,
      spdDisabled: false,
      workZoneCheckbox: false,
      workZoneDisabled: false,
      openWorkflowItemStep: this.props.openWorkflowItemStep
    };
  }

  private workflowController: string = "Workflow";
  transcriberValidationForm = null;
  backgroundSave;
  saving = false;

  private crashKey: any;

  private refreshFormValidity = async () => {
    if (!this.transcriberValidationForm) return false;

    if (this.transcriberValidationForm.getValidationErrorsAfterFlush) {
      const errors = await this.transcriberValidationForm.getValidationErrorsAfterFlush();
      const formIsValid = !errors.some((error) => error.type === "error");
      this.setState({ formIsValid });
      return formIsValid;
    }

    if (this.transcriberValidationForm.isFormValidAfterFlush) {
      const valid = await this.transcriberValidationForm.isFormValidAfterFlush();
      this.setState({ formIsValid: valid });
      return valid;
    }

    const valid = this.transcriberValidationForm.isFormValid
      ? this.transcriberValidationForm.isFormValid()
      : false;
    this.setState({ formIsValid: valid });
    return valid;
  };

  private getSafeFormData = async () => {
    if (!this.transcriberValidationForm) return null;

    if (this.transcriberValidationForm.getLatestFormData) {
      return await this.transcriberValidationForm.getLatestFormData();
    }

    return this.transcriberValidationForm.getFormData();
  };

  loadWorkflowItemStep = () => {
    this.getTranscriberValidationJsonData(this.state.openWorkflowItemStep);
    this.initializeCheckboxes(this.state.openWorkflowItemStep);

    if (
      this.state.openWorkflowItemStep &&
      this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId
    ) {
      this.handleOpenPdf();
    }
  };

  initializeCheckboxes = (openWorkflowItemStep: IWorkflowItemStep) => {
    const hasStatePropertyDamage =
      openWorkflowItemStep.workflowItem.report.keywords.propertyDamageIndicator?.toLocaleLowerCase() ==
      "yes";
    const isWorkzone =
      openWorkflowItemStep.workflowItem.report.keywords.workZoneIndicator?.toLocaleLowerCase() ==
      "yes";
    this.setState({
      spdCheckbox: hasStatePropertyDamage,
      spdDisabled: hasStatePropertyDamage,
      workZoneCheckbox: isWorkzone,
      workZoneDisabled: isWorkzone
    });
  };

  componentDidMount() {
    if (!this.props.returnToAdvancedQuery) {
      if (!this.backgroundSave) {
        this.backgroundSave = setInterval(() => {
          if (this.state.openWorkflowItemStep && !this.saving)
            this.handleComplete(null, false, false, false);
        }, 30000);
      }

      this.loadWorkflowItemStep();
    }
  }

  setSpdCheckbox = () => {
    this.setState({ spdCheckbox: !this.state.spdCheckbox });
    this.setStatePropertyDamage();
  };

  setStatePropertyDamage = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(
        urls.SAVE_STATE_PROPERTY_DAMAGE +
        "?workflowItemStepId=" +
        this.state.openWorkflowItemStep.id,
        {
          ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
          propertyDamageIndicator: this.state.spdCheckbox
        }
      ).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  setWorkZoneCheckbox = () => {
    this.setState({
      workZoneCheckbox: !this.state.workZoneCheckbox,
      workZoneDisabled: true
    });
    this.setWorkZone();
  };

  setWorkZone = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(urls.SAVE_WORK_ZONE_INDICATOR, {
        ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
        workZoneIndicator: this.state.workZoneCheckbox
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  handleSave = (details) => {
    this.handleComplete(details, false, false, false, true);
  };

  getTranscriberValidationJsonData = (
    openWorkflowItemStep: IWorkflowItemStep
  ) => {
    let id;
    if (openWorkflowItemStep != null) {
      id = { id: openWorkflowItemStep.workflowItem.reportId.toString() };
      this.crashKey =
        openWorkflowItemStep.workflowItem.report.keywords.crashKey.toString();
    } else {
      id = "0";
      this.crashKey = "0";
    }

    if (this.crashKey == null) {
      this.crashKey = "No Crash Key Available";
    }

    Api.post(
      urls.GET_REPORT_VALIDATION_JSON_BY_REPORT_ID,
      JSON.stringify(id)
    ).then((response: ApiResponse<any>) => {
      if (response.ok) {
        let formData = response.data;
        console.log("form data from server: ", formData);
        if (
          formData.data.AgencyCaseNo == null ||
          formData.data.AgencyCaseNo == ""
        )
          formData.data.AgencyCaseNo =
            (openWorkflowItemStep.workflowItem.report.keywords.agency.ori ??
              "") +
            (openWorkflowItemStep.workflowItem.report.keywords.crashKey ?? "");
        this.setState({ data: formData });
      }
    });
  };

  checkIsFormValid = (submission: any, formIsValid?: boolean) => {
    if (typeof formIsValid === 'boolean') {
      this.setState({ formIsValid });
      return;
    }

    if (this.transcriberValidationForm && typeof this.transcriberValidationForm.isFormValid === 'function') {
      this.setState({
        formIsValid: this.transcriberValidationForm.isFormValid()
      });
    }
  };

  async handleComplete(
    event: React.MouseEvent<HTMLElement>,
    assignNext: boolean,
    moveToNextWorkflow: boolean,
    continueNavigation: boolean = true,
    manualSave: boolean = false
  ) {
    if (this.saving) {
      console.warn('A save is already in progress');
      return;
    }

    if (!this.transcriberValidationForm) {
      console.log("form not found");
      return;
    }

    if (moveToNextWorkflow) {
      this.setState({ isCompleting: true });
      const isValidNow = await this.refreshFormValidity();
      if (!isValidNow) {
        toast.error("Please correct required fields before completing.");
        this.setState({ isCompleting: false });
        return;
      }
    }

    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.CompletePaperDataTranscriberValidation
    );
    const formData = moveToNextWorkflow
      ? await this.getSafeFormData()
      : this.transcriberValidationForm.getFormData();
    if (!formData) {
      this.setState({ isCompleting: false });
      return;
    }

    if (formData.data?.DateOfCrash?.trim() == "") {
      this.setState({ isCompleting: false });
      return;
    }

    this.saving = true;
    const toastId = continueNavigation || manualSave
      ? toast.info(continueNavigation ? "Completing report..." : "Saving report...", {
        autoClose: false
      })
      : null;

    //console.log('form data: ', formData);
    this.props
      .completeDataTranscriberValidation(
        uri,
        this.state.openWorkflowItemStep,
        formData,
        moveToNextWorkflow,
        assignNext
      )
      .then(async (result: ApiResponse<any>) => {
        if (!result.ok) {
          const message = result.problem || result.originalError?.message || "Error saving!";
          if (toastId) {
            toast.update(toastId, {
              render: message,
              type: "error",
              autoClose: 5000
            });
          } else {
            toast.error(message);
          }
          return;
        }
        this.saving = false;

        if (this.props.returnToAdvancedQuery) {
          try {
            await Api.post(urls.SAVE_FORM_DATA_TO_CRASH_TABLES, {
              reportId: this.props.reportId,
              userId: this.props.currentUser.id
            }).then((result: ApiResponse<any>) => {
              if (result.ok) this.props.history.push("/AdvancedSearch");
              else {
                const message = result.problem || result.originalError?.message || "Error saving!";
                if (toastId) {
                  toast.update(toastId, {
                    render: message,
                    type: "error",
                    autoClose: 5000
                  });
                } else {
                  toast.error(message);
                }
              }
            });
          } catch (ex) {
            console.log(ex);
          }
        }

        if (continueNavigation) {
          if (toastId) {
            toast.update(toastId, {
              render: "Completed",
              type: "success",
              autoClose: 3000
            });
          } else {
            toast.success("Completed");
          }

          if (assignNext) {
            //console.log('new props maybe', this.props);
            this.setState(
              {
                openWorkflowItemStep: this.props.openWorkflowItemStep
              },
              () => {
                this.loadWorkflowItemStep();
              }
            );
          } else this.props.history.push("/DataTranscribeQueue");

          if (assignNext) this.props.history.push("/DataTranscriberValidation");
          else this.props.history.push("/DataTranscriberValidationQueue");
        } else {
          if (manualSave) {
            if (toastId) {
              toast.update(toastId, {
                render: "Saved",
                type: "success",
                autoClose: 3000
              });
            } else {
              toast.success("Saved");
            }
          }
        }
      })
      .catch((ex) => {
        const message = ex?.message || "Error saving or completing";
        if (toastId) {
          toast.update(toastId, {
            render: message,
            type: "error",
            autoClose: 5000
          });
        } else {
          toast.error(message);
        }
        console.log(ex);
      })
      .finally(() => {
        this.saving = false;
        this.setState({ isCompleting: false });
      });
  }

  handleOpenPdf = () => {
    console.log("bypassReportImage: ", this.props.bypassReportImage);
    if (this.props.bypassReportImage) return;
    documentDownloadService
      .openOnBaseImage(
        null,
        this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId
      )
      .then();
  };

  sendToManagementQueue = () => {
    try {
      this.handleSave(null);
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.state.openWorkflowItemStep.id
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: "/DataTranscriberValidationQueue"
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  componentWillUnmount() {
    clearInterval(this.backgroundSave);
    this.backgroundSave = null;
  }

  public render() {
    const allButtons = (
      <React.Fragment>
        <br />
        {!this.props.returnToAdvancedQuery && (
          <React.Fragment>
            <div className="completeAndStartNextButton">
              <Button
                variant="success"
                size="sm"
                onClick={(e) => this.handleComplete(e, true, true)}
                disabled={!this.state.formIsValid || this.state.isCompleting}
              >
                Complete and Start Next Report{" "}
              </Button>
            </div>
            <div className="completeButton">
              <Button
                variant="success"
                size="sm"
                onClick={(e) => this.handleComplete(e, false, true)}
                disabled={!this.state.formIsValid || this.state.isCompleting}
              >
                Complete
              </Button>
            </div>
          </React.Fragment>
        )}

        <div className="saveReportButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleSave(e)}
          >
            Save Report
          </Button>
        </div>
      </React.Fragment>
    );

    return (
      <div>
        <Row>
          <Col>
            <div className="workZoneCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Work Zone"
                  disabled={this.state.workZoneDisabled}
                  checked={this.state.workZoneCheckbox}
                  onChange={this.setWorkZoneCheckbox}
                />
              </Form.Group>
            </div>
            <div className="spdCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="State Property Damage"
                  checked={this.state.spdCheckbox}
                  onChange={this.setSpdCheckbox}
                />
              </Form.Group>
            </div>
          </Col>
          <Col className="justify-content-end">
            {" "}
            <NotificationTemplateSelector
              optionId={optionIds.transcribeValidationOptionId}
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
            />
          </Col>
          <Col xs={2} className="justify-content-end">
            <CommentsButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right"
              placement="left"
            />
            <CorrespondenceButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right mr-10"
            />
          </Col>
        </Row>
        <InfoButtonBar
          report={this.state.openWorkflowItemStep.workflowItem.report}
          handleOpenPdf={this.handleOpenPdf}
          sendToManagementQueue={this.sendToManagementQueue}
        />
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        {this.state.data && Object.keys(this.state.data).length > 0 && (
          <DataTranscriberValidationForm
            key={this.state.openWorkflowItemStep.id}
            data={this.state.data}
            injectToSidebar={this.props.readOnly != true ? allButtons : ""}
            ref={(el) => (this.transcriberValidationForm = el)}
            onChange={this.checkIsFormValid}
            readOnly={this.props.readOnly}
            formId={this.props.openWorkflowItemStep.workflowStep.formIoFormId}
          />
        )}
        {!this.state.data && <strong>Loading Form...</strong>}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep:
      state.DataTranscriberValidationQueue.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    bypassReportImage: state.Application.bypassReportImage
  };
}

const mapDispatchToProps = {
  completeDataTranscriberValidation
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataTranscriberValidation)
);
